<template>
    <div class="animated fadeIn">
      <b-form @submit.stop.prevent="onSubmit">

       


        <b-card class="card-accent-info" header="KPI Indicadores de Desempenho">
            <b-card-body>

                <div v-for="bar in bars" class="row mb-1">
                    <div class="col-sm-4">{{ bar.name }}:</div>
                    <div class="col-sm-8 pt-1">
                        <b-progress :value="bar.value" :variant="bar.variant" :key="bar.variant"></b-progress>
                    </div>
                </div>
                
                <b-row>
                    <b-col cols="auto" class="mr-auto">
                        
                    <!--
                        <b-form-group>
                            <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                            &nbsp;
                            <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                            &nbsp;
                            <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
                        </b-form-group>
                    -->
                    </b-col>
                    <b-col cols="auto" class="">
                    <b-form-group>
                        <!--
                        <b-button variant="github" class="mr-1 btn-brand" @click="manualInsert()"><i class="fa fa-plus"></i><span>Inserção Manual</span></b-button>
                        -->
                    </b-form-group>
                    </b-col>
                </b-row>
                    

                <b-row>
                  
                    <b-col cols="auto">
                    <b-form-group>
                        <label for="name" style="font-size: 0.8em">Filtro</label>
                        <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
                    </b-form-group>
                    </b-col>

                    <b-col cols="auto">
                    <b-form-group>
                        <label for="status" style="font-size: 0.8em">Status</label>
                        <b-form-select id="status"
                            v-model="filters.status"
                            :plain="true"
                            :options="statusddl"
                            :value="[null,'c']">
                        </b-form-select>
                    </b-form-group>
                    </b-col>
            
                    <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                    <b-form-group>
                        <p></p>
                        <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                    </b-form-group>
                    </b-col>
        
                    
                    <b-col cols="auto" class="">
                    <b-form-group >
                        <label for="perPage">Linhas</label>
                        <b-form-select v-model="table.perPage" id="perPage"
                            :plain="true"
                            :options="[5,10,20,50]">
                        </b-form-select>
                        </b-form-group>
                    </b-col>
                    
                </b-row>

                <b-table
                    :items="filteredItems"
                    :fields="table.fields"
                    :select-mode="table.selectMode"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    :primary-key="table.primaryKey"
                    :tbody-transition-props="table.transProps"
                    sort-icon-left
                    @row-selected="onRowSelected"
                    :per-page="table.perPage"
                    :current-page="table.currentPage"
                    :busy="table.isBusy"
                    hover
                    striped>

                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>

                    <template v-slot:cell(st)="data">
                        <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='1'" label variant="pill" v-bind="switchLabelIcon" /> 
                    </template>
                    
                    <template v-slot:cell(ispublic)="data">
                        <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                    </template>
                    
                    <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="primary" @click="seqUp(data.item)" class="mr-1 btn-brand"><i class="fa fa-arrow-up" alt="Mover para cima" title="Mover para cima"></i></b-button>
                    <b-button size="sm" variant="primary" @click="seqDown(data.item)" class="mr-1 btn-brand"><i class="fa fa-arrow-down" alt="Mover para baixo" title="Mover para baixo"></i></b-button>
                    </template>
                    
                </b-table>


             

            </b-card-body>
        </b-card>

      </b-form>

    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  import TransactionComponent from './TransactionComponent.vue'
  import TransactionManualInsertComponent from './TransactionManualInsertComponent.vue'
  
  import { Switch as cSwitch } from '@coreui/vue'

  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'Transaction',
      computed: {
        selectedItem() {
            return this.item
        },
        totalRows: function () { return this.getRowCount() },
        filteredItems() {
            try {
                return this.items.filter(item => {
                    return (this.filters.key == '' || (
                        this.$utils.filterString(item.name, this.filters.key)                        
                        //|| this.$utils.filterString(item.departmentName, this.filters.key)
                        //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                        //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                        //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                        ))
                        //&& (this.filters.departmentId == 0 || (this.filters.departmentId == item.departmentId))
                        //&& (this.filters.typeId == 0 || (this.filters.typeId == item.typeId))
                        //&& (this.filters.statusId == 0 || (this.filters.statusId == item.statusId ))
                        && (this.filters.status==-1 || item.st == this.filters.status )
                        
                                    
                })
            }
            catch(e) {
                return this.items;
            }
        }
      },
      components: {
        cSwitch,
        TransactionComponent,
        TransactionManualInsertComponent
      },
      data: () => {
          return {
            bars: [
                { name: 'Disponibilidade do ponto de cobrança', variant: 'success', value: 75 },
                { name: 'Taxa de detecção do veículo', variant: 'info', value: 75 },
                { name: 'Índice de captura de Placas dianteiras', variant: 'warning', value: 75 },
                { name: 'Índice de captura de Placas traseiras', variant: 'danger', value: 75 },
                { name: 'Taxa de decodificação pelo OCR do LPR', variant: 'primary', value: 75 },
                { name: 'Taxa de falso positivo do OCR pelo LPR', variant: 'secondary', value: 75 },
                { name: 'Taxa de classificação de veículos', variant: 'dark', value: 75 }
            ],
            timer: null,
            tabInfo: 'C',
            manualInsertModal: false,
            items: [],
            plazaDDL: [],
            laneDDL: [],
            filters: {
                plaza: 0,
                lane: 0,
                status: -1
            },
            table: {
                fields: [
                    //{key: 'show_details', label: "", thStyle: { width: "40px" } },
                    //{key: 'idtransaction', label: 'Transação', sortable: true, class: 'text-center' },
                    //{key: 'costcenter', label: 'Centro de Custo', sortable: true },
                    {key: 'action', label: '', sortable: false, thStyle: { width: "90px" }, tdClass: 'align-middle' },
                    {key: 'name', label: 'KPI', sortable: true },
                    //{key: 'lane', label: 'Pista', sortable: true },
                    //{key: 'seqtrans', label: 'Sequencial', sortable: true },
                    //{key: 'plate', label: 'Placa', sortable: true },
                    //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
                    //{key: 'totalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                    //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                    //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
                    //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
                    {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } },
                    
                ],
                modes: ['multi', 'single', 'range'],
                selectMode: 'multi',
                primaryKey: 'id',
                isBusy: false,
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                transProps: {
                    name: 'flip-list'
                }
            },
            switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            },
            switchLabelTxt: {
                dataOn: 'yes',
                dataOff: 'no'
            },
            statusddl: [
                {
                    text: '- Todos -',
                    value: -1
                },
                {
                    text: 'Ativo',
                    value: '1'
                },
                {
                    text: 'Inativo',
                    value: '0'
                }
            ],
          }
      },
      methods: {
        seqUp(item) {

        },
        seqDown(item) {

        },
        onRowSelected() {

        },
        manualInsert() {
            this.manualInsertModal = true
        },
        async refreshData() {
            var s = this
            var currentUser = this.$store.state.currentUser
            this.isBusy = true

            //console.log(this.$store.state.ws_url + "/freeflow/kpi?uid=" + currentUser.id + "&sid=" + currentUser.sid)

            await axios.get(
                this.$store.state.ws_url + "/freeflow/kpi?uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.items = resp.data.obj;
            }
            ).catch(function (error) {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Erro',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            })

            this.isBusy = false;
        }
      }
      ,
      mounted: function() {
        this.refreshData(),
        this.timer = setInterval(() => {
            this.bars.forEach(bar => (bar.value = 25 + Math.random() * 75))
        }, 2000)
      },
      beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  
  </script>